"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepeatingTableRowContext = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var TokenInput_1 = __importStar(require("Project/QwilrEditor/Widgets/TokenMenu/TokenInput"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Types_1 = require("ContentTokens/Models/inputs/Types");
var Types_2 = require("@CommonFrontendBackend/Tokens/Types");
var TokenSearchContext_1 = __importDefault(require("Project/QwilrEditor/Providers/TokenScope/TokenSearchContext"));
var classnames_1 = __importDefault(require("classnames"));
var Types_3 = require("Tokens/Types");
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var slate_1 = require("slate");
var Types_4 = require("@CommonFrontendBackend/ContentTokens/Types");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var TableStyleStore_1 = require("Project/QwilrEditor/Widgets/TableWidget/TableStyleStore");
var TableWidgetContext_1 = require("Project/QwilrEditor/Widgets/TableWidget/TableWidgetContext");
var DefaultSchema_1 = require("Project/QwilrEditor/Schemas/DefaultSchema");
var SubstitutionTokenFactory_1 = __importDefault(require("Tokens/SubstitutionTokenFactory"));
exports.RepeatingTableRowContext = react_1.default.createContext(null);
var RepeatingTableRow = (function (_super) {
    __extends(RepeatingTableRow, _super);
    function RepeatingTableRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shouldRenderPlaceholder = function () {
            var e_1, _a;
            var element = _this.props.element;
            var descendants = slate_1.Node.descendants(element);
            try {
                for (var descendants_1 = __values(descendants), descendants_1_1 = descendants_1.next(); !descendants_1_1.done; descendants_1_1 = descendants_1.next()) {
                    var _b = __read(descendants_1_1.value, 2), descendantNode = _b[0], descendantNodePath = _b[1];
                    if (slate_1.Text.isText(descendantNode)) {
                        if (descendantNode.text.length != 0) {
                            return false;
                        }
                    }
                    else {
                        if (RepeatingTableRow_1.visibleChildNodes.has(descendantNode.type)) {
                            return false;
                        }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (descendants_1_1 && !descendants_1_1.done && (_a = descendants_1.return)) _a.call(descendants_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return true;
        };
        _this.handleTokenChange = function (token) {
            if (!(0, Types_3.isListToken)(token)) {
                return;
            }
            var repeatingToken = new Types_1.RepeatingTokenInput(token.apiName, token.name, token.childObjectType, token.childPropertyLabel, SubstitutionTokenFactory_1.default.fromLegacyApiToken(token));
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_4.WidgetBlockType.Table, {
                action: EditorTypes_1.TableActionType.SetRepeatingRowToken,
                path: _this.props.widgetManager.getPath(_this.props.element),
                repeatingToken: repeatingToken,
            }));
        };
        return _this;
    }
    RepeatingTableRow_1 = RepeatingTableRow;
    RepeatingTableRow.prototype.render = function () {
        var _a;
        var _this = this;
        var className = "repeating-table-row";
        var _b = this.props, attributes = _b.attributes, token = _b.token, children = _b.children, isHeaderRow = _b.isHeaderRow;
        var tableStyleStore = this.context.tableStyleStore;
        var theme = isHeaderRow ? tableStyleStore.headerTheme : tableStyleStore.backgroundTheme;
        var repeatingRowMenu = function () {
            return (react_1.default.createElement("div", { className: "".concat(className, "__input-wrapper"), contentEditable: false },
                react_1.default.createElement("span", { className: "".concat(className, "__label") }, "Repeat row for every"),
                react_1.default.createElement("span", { className: "".concat(className, "__token-input") },
                    react_1.default.createElement(TokenSearchContext_1.default.Provider, { value: null },
                        react_1.default.createElement(TokenInput_1.default, { type: Types_2.TokenDataType.List, token: token ? __assign(__assign({}, token), { type: Types_2.TokenDataType.List }) : undefined, onTokenChange: _this.handleTokenChange, onTokenMatchedBySearch: function () { }, variant: kaleidoscope_1.TextInputVariant.Bordered, theme: theme === TableStyleStore_1.TableTheme.Dark ? TokenInput_1.TokenInputTheme.Dark : TokenInput_1.TokenInputTheme.Light, size: kaleidoscope_1.TextInputSize.Small, endElement: react_1.default.createElement(icons_1.ChevronDown, null) }))),
                _this.shouldRenderPlaceholder() && (react_1.default.createElement("span", { className: "".concat(className, "__placeholder") },
                    "Type ", "{{",
                    " to add repeating token properties"))));
        };
        return (react_1.default.createElement("tr", __assign({ className: (0, classnames_1.default)(className, (_a = {},
                _a["".concat(className, "--light")] = theme === TableStyleStore_1.TableTheme.Light,
                _a["".concat(className, "--dark")] = theme === TableStyleStore_1.TableTheme.Dark,
                _a["table-header-row"] = isHeaderRow,
                _a)) }, attributes),
            react_1.default.createElement(TokenSearchContext_1.default.Provider, { value: token },
                react_1.default.createElement(exports.RepeatingTableRowContext.Provider, { value: { repeatingRowMenu: repeatingRowMenu() } }, children))));
    };
    var RepeatingTableRow_1;
    RepeatingTableRow.contextType = TableWidgetContext_1.TableWidgetContext;
    RepeatingTableRow.visibleChildNodes = (function () {
        var validTableCellChildren = DefaultSchema_1.schema.blocks.tableCell.validChildren;
        var validLeafNodes = new Set();
        validTableCellChildren.forEach(function (child) {
            validLeafNodes.add(child);
            DefaultSchema_1.schema.blocks[child].validChildren.forEach(function (leaf) { return validLeafNodes.add(leaf); });
        });
        validLeafNodes.delete(EditorTypes_1.BlockType.Paragraph);
        return validLeafNodes;
    })();
    RepeatingTableRow = RepeatingTableRow_1 = __decorate([
        mobx_react_1.observer
    ], RepeatingTableRow);
    return RepeatingTableRow;
}(react_1.default.Component));
exports.default = RepeatingTableRow;
